import { httpService } from '@/apps/common/modules/common/services/http.service';
// import { socketService } from '@/apps/common/modules/common/services/socket.service';
import { appendScript } from "./loadScript.service";
import { Utils } from './util.service';
import { TaskManager } from './TaskManager';

const ENDPOINT = 'file';

import config from '@/config';
const BASE_URL = config.baseApiUrl

export const fileUtilsService = {};
export const fileService = {
  uploadFileToServer,
  fileUtilsService,
  resizeImage
}

// loading the script file from the server so it is writen only once;
appendScript('/fileUtils-service', 'fileUtilsModule', fileUtilsService);


export function getFileError(file = {}, rootData) {
  return fileUtilsService.getFileError(file, rootData);
}
export function getFileItemFromRootItem(file = {}, rootData) {
  return fileUtilsService.getFileItemFromRootItem(file, rootData);
}
export function fixFileSrcToThumbnail(file = {}, rootData) {
  return fileUtilsService.getFileThumbnailUrlFromRootData(file, rootData, config);
  // return fileUtilsService.getFileThumbUrl(file, config);
}

export function fixVideoSrcToThumbnail(file = {}, rootData, organizationId = '') {
  return fileUtilsService.getFileThumbnailUrlFromRootData(file, rootData, config);
  // return fileUtilsService.getVideoThumbUrl(file, organizationId, config);
}

export async function resizeImage(file, { quality = 1.0, maxSize = 20 * 1024 * 1024 } = {}) {
  // Only process images (excluding SVGs) that exceed the max size
  if (!file.type.startsWith('image/') || file.type.includes('svg')) return file;
  if (file.size <= maxSize) return file;

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = async () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        
        // Use better image smoothing
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        
        ctx.drawImage(img, 0, 0, width, height);

        const tryBlob = (q) => new Promise(r => canvas.toBlob(r, file.type, q));

        // Start with requested quality (default 1.0)
        let bestBlob = await tryBlob(quality);
        
        // If still too large, try reducing quality (for lossy formats)
        if (bestBlob.size > maxSize && (file.type === 'image/jpeg' || file.type === 'image/webp')) {
          for (let q = 0.9; q >= 0.5; q -= 0.1) {
            const blob = await tryBlob(q);
            if (blob.size <= maxSize) {
              bestBlob = blob;
              break;
            }
            bestBlob = blob; // Keep the smallest one we found so far
          }
        }

        // If it's a PNG or quality reduction wasn't enough, we must scale to meet the maxSize requirement
        if (bestBlob.size > maxSize) {
          let scale = 0.9;
          while (bestBlob.size > maxSize && scale > 0.1) {
            const w = Math.floor(img.width * scale);
            const h = Math.floor(img.height * scale);
            canvas.width = w;
            canvas.height = h;
            ctx.drawImage(img, 0, 0, w, h);
            bestBlob = await tryBlob(file.type === 'image/png' ? undefined : 0.8);
            if (bestBlob.size <= maxSize) break;
            scale -= 0.1;
          }
        }
        
        // Create a new File object from the blob
        const resizedFile = new File([bestBlob], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
        
        // If the "resized" file is somehow larger than original, return original
        if (resizedFile.size > file.size) resolve(file);
        else resolve(resizedFile);
      };
      img.onerror = () => {
        console.error('Failed to load image for resizing');
        resolve(file); // Fallback to original file
      };
      img.src = e.target.result;
    };
    reader.onerror = () => {
      console.error('Failed to read file for resizing');
      resolve(file); // Fallback to original file
    };
    reader.readAsDataURL(file);
  });
}
// export function getTotalTimeWatchedPerVideoWatchLog(vidLog) {
//   return fileUtilsService.getTotalTimeWatchedPerVideoWatchLog(vidLog);
//   // return fileUtilsService.getVideoThumbUrl(file, organizationId, config);
// }
// export function checkIfLogCounts(vidLog) {
//   return fileUtilsService.checkIfLogCounts(vidLog);
//   // return fileUtilsService.getVideoThumbUrl(file, organizationId, config);
// }


export async function uploadFileToServer(file, organizationId, parentData) {
  file = await resizeImage(file);
  const formData = new FormData();
  formData.append('file', file);
  const fileSize = file.size;
  return httpService.post(`${ENDPOINT}/upload/${organizationId}`, formData, {parentData, isFullFile: true, fileSize});
}

export async function chunkUploadFileToServer(file, organizationId, parentData, onChunkEndCb = (uploadStats) => {}) {
  file = await resizeImage(file);
  const CHUNK_SIZE = 1024 * 1024 * 10; // 10MB;

  const fileSize = file.size;
  const originalName = file.name;

  const totalChunks = Math.ceil(fileSize / CHUNK_SIZE);  

  const lastDotIdx = file.name.lastIndexOf('.');
  const type = lastDotIdx > -1 ? file.name.substring(lastDotIdx+1) : file.mimetype?.split('/').pop();
  const storeFileName = `file-${Utils.getRandomId()}.${type}`;

  
  const isVideo = ['mp4'].includes(type);
  let mediaSecondsDuration = 0;
  if (isVideo && false) {
    mediaSecondsDuration = await new Promise((resolve, reject) => {
      const videoUrl = URL.createObjectURL(file);
      const videoEl = document.createElement('video');
      videoEl.preload = 'metadata';
      videoEl.onloadedmetadata = () => {
        URL.revokeObjectURL(videoUrl);
        resolve(videoEl.duration)
      }
      videoEl.onerror = () => {
        console.error('Cant load video length');
        resolve(0)
      }
    });
  }
  
  const prms = [];
  const baseParams = {parentData, fileSize, mediaSecondsDuration, totalChunks, storeFileName, originalName, chunkSize: CHUNK_SIZE};
  let uploadId;
  const chunkByChunkMode = true;
  if (!chunkByChunkMode) uploadId = await httpService.post(`${ENDPOINT}/openMultipartUpload/${organizationId}`, null, baseParams);
  let res;
  let uploadedBytes = 0;
  let socketRoom = '';
  // const isEncryptionMode = false;
  let doneChunksCount = 0;
  const tasker = new TaskManager(undefined, 1, 1);
  for (let i = 0; i < totalChunks; i++) {
    const doIt = async () => {
      const start = i * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, fileSize);
      const chunk = file.slice(start, end);
      const formData = new FormData();
      formData.append('file', chunk);
      const params = {...baseParams, uploadId, chunkIdx: i, range: {start, end}, chunkByChunkMode};
      if (!i) params.isFirst = true;
      if (i === totalChunks - 1) params.isLast = true;
      const currRes = await httpService.post(`${ENDPOINT}/upload/${organizationId}`, formData, params);
      if (!uploadId) { // if firstTime, if no uploadId
        // res = currRes;
        uploadId = currRes.uploadId;
      } 
  
      uploadedBytes += CHUNK_SIZE;
      doneChunksCount++;
      // onChunkEndCb?.({ uploadedBytes, totalSize: fileSize, percents: Math.min((uploadedBytes / fileSize)*100, 100), msg: '' });
      onChunkEndCb?.({ uploadedBytes, totalSize: fileSize, percents: Math.min((doneChunksCount / totalChunks)*100, 100), msg: '' });
  
      if (i === totalChunks - 1) {
        if (chunkByChunkMode) {
          res = currRes;
        }
        // if (isEncryptionMode) {
        //   socketRoom = currRes.socketRoom;
        //   // socketService.emit('join-room', socketRoom);
        //   onChunkEndCb?.({ uploadedBytes, totalSize: fileSize, percents: Math.min((uploadedBytes / fileSize)*100, 100), msg: 'encrypting' });
        //   res = await (new Promise((resolve, reject) => {
        //     // socketService.on('encryption-finished', data => resolve(data));
        //   }));
        // }
      } else {
      }
    }
    // const prm = doIt();
    const prm = tasker.appendTask(doIt);
    if (chunkByChunkMode) await prm;
    else prms.push(prm);
    // uploadedBytes += CHUNK_SIZE;
  }
  if (!chunkByChunkMode) {
    await Promise.all(prms);
    res = await httpService.post(`${ENDPOINT}/closeMultipartUpload/${organizationId}`, null, {...baseParams, uploadId});
  }
  return res;
}

export function loadStaticFile(filePath) {
  return httpService.get(`${ENDPOINT}/static-file`, { filePath });
}
export function loadCostumeHtml(orgId, filePath) {
  return httpService.get(`${ENDPOINT}/costumeHtml/${orgId}`, { filePath });
}

export function getVideoEncryptionKey(token) {
  return httpService.get(`${ENDPOINT}/encryption-key`, { });
}

export function getFreshFileUrl(fileId, organizationId, releaseId) {
  const params = releaseId ? { releaseId } : {};
  return httpService.get(`${ENDPOINT}/url/${organizationId}/${fileId}`, params);
}

export function listCloudFiles(organizationId, params = {}) {
  return httpService.get(`${ENDPOINT}/list-cloud/${organizationId}`, params);
}

export function registerCloudFile(organizationId, data) {
  return httpService.post(`${ENDPOINT}/register-cloud/${organizationId}`, data);
}

export function getFileStatus(fileId) {
  return httpService.get(`${ENDPOINT}/status/${fileId}`);
}

